package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.plandefinition.data.remote.dto.series.SimpleFloatingSeriesDto
import com.exura.features.plandefinition.domain.model.series.SimpleFloatingSeries
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Mapper for converting between SimpleFloatingSeries domain model and DTO.
 * Implements BaseSeriesMappers for Firebase storage compatibility.
 */
class SimpleFloatingSeriesMappers : BaseSeriesMappers<SimpleFloatingSeries, SimpleFloatingSeriesDto> {
    override fun toDto(model: SimpleFloatingSeries): SimpleFloatingSeriesDto = SimpleFloatingSeriesDto(
        name = model.title,
        description = model.description,
        seriesType = model.seriesSpawnType,
        durationInDays = model.durationInDays(),
        instruction = model.instruction,
        estimatedMinutes = model.durationInMinutes,
        deadline = model.deadline,
        exactTime = model.exactTime,
        imageUrl = model.imageUrl,
    )

    override fun toDomain(dto: SimpleFloatingSeriesDto, collection: CollectionReference?, id: String?): SimpleFloatingSeries = SimpleFloatingSeries(
        firebaseDocId = id,
        firebaseDocPrefix = collection,
        title = dto.name,
        description = dto.description,
        elements = emptyList(), // Elements would be loaded separately
        instruction = dto.instruction,
        durationInMinutes = dto.estimatedMinutes,
        deadline = dto.deadline,
        exactTime = dto.exactTime,
        imageUrl = dto.imageUrl,
    )
}
